module.exports = __webpack_public_path__ + "img/744.7e9f8ef0.jpg";